<mwe-modal [model]="popupModel()">
  <p [innerHTML]="loadedData?.description | translate" class="text--big mb-0" data-test="info-text-popup-text"></p>
  @if (loadedData?.link?.target && loadedData?.link?.name) {
    <a
      [href]="loadedData?.link.target"
      class="d-block font-size-14 fw-500 mt-4 mb-2 text-uppercaseblue"
      data-test="info-text-popup-link"
      target="_blank"
    >
      {{ loadedData?.link.name | translate }}
    </a>
  }
</mwe-modal>
